export const GET_ANALYSIS = 'GET_ANALYSIS';
export const GET_STORY = 'GET_STORY';
export const DELETE_STORY = 'DELETE_STORY';
export const GET_FULL_STORY = 'GET_FULL_STORY';
export const GET_FULL_STORY_FAIL = 'GET_FULL_STORY_FAIL';
export const GET_STORY_CHAPTERS = 'GET_STORY_CHAPTERS';
export const GET_STORY_CHAPTERS_FAIL = 'GET_STORY_CHAPTERS_FAIL';
export const GET_STORY_LENGTH = 'GET_STORY_LENGTH';
export const GET_STORY_LENGTH_FAIL = 'GET_STORY_LENGTH_FAIL';
export const REMOVE_ANALYSIS = "REMOVE_ANALYSIS";
export const SAVED_SUCCESS = "SAVED_SUCCESS";
export const SAVED_FAIL = "SAVED_FAIL";
export const GET_SAVED_RESPONSE_SUCCESS = "GET_SAVED_RESPONSE_SUCCESS";
export const GET_SAVED_RESPONSE_FAIL = "GET_SAVED_RESPONSE_FAIL";
export const POST_SETTINGS_SUCCESS = "POST_SETTINGS_SUCCESS";
export const POST_SETTINGS_FAIL = "POST_SETTINGS_FAIL";
export const GET_SETTINGS_SUCCESS = "GET_SETTINGS_SUCCESS";
export const GET_SETTINGS_FAIL = "GET_SETTINGS_FAIL";
export const GET_BOOK_SUCCESS = "GET_BOOK_SUCCESS";
export const GET_BOOK_FAIL = "GET_BOOK_FAIL";
export const POST_PLAYTIME_SUCCESS = "POST_PLAYTIME_SUCCESS";
export const POST_PLAYTIME_FAIL = "POST_PLAYTIME_FAIL";
export const SETTINGS_PANEL = "SETTINGS_PANEL";
export const CLOSE_PANEL = "CLOSE_PANEL";
export const SOUND_SETTINGS_PANEL = "SOUND_SETTINGS_PANEL";
export const SET_INPUT_DEVICE = "SET_INPUT_DEVICE";
export const SET_OUTPUT_DEVICE = "SET_OUTPUT_DEVICE";
export const SAVE_LOCAL_DATA = "SAVE_LOCAL_DATA";
export const GET_STORY_FAIL = "GET_STORY_FAIL";
export const SETTINGS_MENU_OPEN = "SETTINGS_MENU_OPEN";
export const MODAL_STATE = "MODAL_STATE";
export const ADD_LAZY_FLAG = "ADD_LAZY_FLAG";
export const RESET_LAZY_FLAG = "RESET_LAZY_FLAG";